import React from "react";
import CardSolde from "../../../../components/Cards/CardSolde/CardSolde";
import {
    Alert,
    ExclamationTriangleIcon,
    Flex,
    InputLabel,
    Loader,
    Text,
} from "@fluentui/react-northstar";
import StepTitle from "../../../../components/StepsTitle/StepTitle";
import FooterActionButtons from "../../components/footer/FooterActionButtons";
import useLogicStepSolde from "../../hooks/useLogicStepSolde";

const StepSolde = () => {
    const { query, navigation } = useLogicStepSolde();

    if (query.isLoading) {
        return <Loader label="Chargement ..." />;
    }

    if (!query.data) {
        return (
            <Alert
                content="Une erreur est survenue ! Veuillez réessayer plus tard !"
                icon={<ExclamationTriangleIcon />}
                danger
            />
        );
    }

    return (
        <Flex fill column space="between" gap="gap.large">
            {/* title */}
            <Flex column gap="gap.large">
                <StepTitle title="Solde de congés" step_number={3} />
            </Flex>
            {/* politique d'absence */}
            <Flex column gap="gap.smaller">
                <Text
                    content="Politique d'absence"
                    size="small"
                    style={{ color: "#616161" }}
                />
                <Text
                    content={query.formated_data.leave_policy_name}
                    size="medium"
                />
            </Flex>
            {/* solde actuel */}
            <Flex>
                <CardSolde.CardSoldeWrapper title={"Solde actuel"}>
                    <CardSolde
                        employee_data={query.formated_data.current_balances}
                    />
                </CardSolde.CardSoldeWrapper>
            </Flex>
            {/* solde départ */}
            <Flex>
                <CardSolde.CardSoldeWrapper title={"Solde à la date de départ"}>
                    <CardSolde
                        employee_data={query.formated_data.futur_balances}
                    />
                </CardSolde.CardSoldeWrapper>
            </Flex>
            {/* Footer */}
            <FooterActionButtons
                enableButtonBackStep={true}
                enableButtonNextStep={true}
                onClickNextStep={navigation.buttonNextStep}
                onClickBackStep={navigation.buttonBackStep}
            />
        </Flex>
    );
};

export default StepSolde;
